import React, { createContext, useContext, useReducer } from 'react';

const AccountContext = createContext({});

const reducer = (state, action) => {
	switch (action.type) {
		// case 'TOGGLE_TEST':
		// 	return {
		// 		...state,
		// 		promotion:{
		// 			...state.promotion,
		// 			Promotion:{
		// 				...state.promotion.Promotion,
		// 				test:action.test_mode
		// 			}
		// 		}
		// 	}
	
		default:
			return state;
	}
}

function MyAccount(initial) {
	this.account = initial;

	this.PLAN_WL = 5;

	this.hasMinPlan = function(minType) {
		if(this.account.plan == undefined) return false;

		if(parseInt(this.account.plan.plan_type) >= parseInt(minType)) return true;

		return false;
	}

	this.isCorporate = function () {
		return this.account.plan && parseInt(this.account.plan.plan_type) > 5 ? true : false;
	}
	
	this.availableDomains = function (minType) {
		const limit = this.hasMinPlan(6) && this.isCorporate() ? 5 : (this.hasMinPlan(5) ? 1 : 0)
		return this.account.account?.max_domains ?? limit
	}

	this.availableExtraDomains = function (minType) {
		return this.account.account?.extra_domains ?? 0
	}

	this.availableAgents = function (minType) {
		//const limit = this.hasMinPlan(6) && this.isCorporate() ? 5 : (this.hasMinPlan(5) ? 1 : 0)
		return this.account.account?.max_agents ?? 0
	}

	this.availableExtraAgents = function (minType) {
		return this.account.account?.extra_agents ?? 0
	}

	this.getAccountId = function () {
		return this.account.account.id;
	}

	this.getPlan = function () {
		return this.account.plan;
	}

	this.getPlanPeriod = function () {
		return this.account.plan  ? (this.account.plan.pay_mode == 1 ?  'Yearly' : 'Monthly') : false;
	}

	this.getAgentLang = function () {
		return this.account.agent?.default_lang ?? null;
	}

	this.getAgentEmail = function () {
		return this.account.agent?.email ?? null;
	}

	this.getAgentHourFormat = function () {
		return this.account.agent?.hourformat ?? '24';
	}

	this.getAgentDateTimeFormat = function () {
		const hourformat = this.getAgentHourFormat();
		return (hourformat == '24') ? 'L, HH:mm [h]' : 'L, hh:mm A';
	}

	this.getAgentTimezone = function () {
		return this.account.agent?.timezone ?? 'Europe/Madrid';
	}

}

export const AccountProvider = (props) => {
	const [ data, dispatch ] = useReducer(reducer, props.myAccount);

	const account = new MyAccount(props.myAccount);
	const actions = {};
	
	return (
		<AccountContext.Provider value={{MyAccount:account}}>
			{props.children}
		</AccountContext.Provider>
	)
};

export const useAccount = () => {
	return useContext(AccountContext);
};